angular.module('psModule').controller('GroupinsuranceCtrl', function ($scope, $translate) {
    $scope.individualId = individualId();
    $scope.lang = () => $translate.use();

    function individualId() {
        return $scope.$root.config && $scope.$root.config.individualId || null;
    }

});
